import { render, staticRenderFns } from "./BoldParagraphText.vue?vue&type=template&id=9a354b96"
import script from "./BoldParagraphText.vue?vue&type=script&lang=js"
export * from "./BoldParagraphText.vue?vue&type=script&lang=js"
import style0 from "./BoldParagraphText.vue?vue&type=style&index=0&id=9a354b96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports